export const PHONE_DISPLAY = "+91 7417551772";
export const PHONE_TEL = "tel:+917417551772";
export const WA_NUMBER = "917417551772";
export const INSTAGRAM_HANDLE = "@yogicaryanthakur";
export const INSTAGRAM_URL = "https://www.instagram.com/yogicaryanthakur";

export const YOUTUBE_HANDLE = "@yogicaryan";
export const YOUTUBE_URL = "https://youtube.com/@yogicaryan?si=mx_hEzfyERL41axZ";

export const waLink = (text) =>
    `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(text)}`;

export const IMG = {
    hero: "https://customer-assets-0z36b82j.emergentagent.net/job_56c9f21c-c0d9-46dc-8b6f-fca45d3f9620/artifacts/3mzke137_image.png",
    profile:
        "https://customer-assets-0z36b82j.emergentagent.net/job_56c9f21c-c0d9-46dc-8b6f-fca45d3f9620/artifacts/l6jhs32e_image.png",
    inversion:
        "https://customer-assets-0z36b82j.emergentagent.net/job_56c9f21c-c0d9-46dc-8b6f-fca45d3f9620/artifacts/fs1y73r7_image.png",
};
